import React, { useEffect, useState } from 'react';
import {
  Box,
  Container,
  TextField,
  Typography,
  Button,
  Avatar,
  CircularProgress,
  IconButton as MUIIconButton,
  Divider,
  Snackbar,
  Alert
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Footer from '../Materials/Footer';
import BurgerBar from '../Materials/BurgerBar';


export default function UserSettings() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [userDetails, setUserDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [editedDetails, setEditedDetails] = useState(null);

  const [notification, setNotification] = useState({
    open: false,
    message: '',
    severity: 'success'
  });

  const showNotification = (message, severity = 'success') => {
    setNotification({
      open: true,
      message,
      severity
    });
  };

  const handleCloseNotification = () => {
    setNotification((prev) => ({
      ...prev,
      open: false
    }));
  };


  useEffect(() => {
    if (user && user.userId) {
      const fetchUserDetails = async () => {
        try {
          const response = await fetch(`https://api.hub4food.colab4food.com/api/users/${user.userId}`);
          const data = await response.json();
          if (response.ok) {
            setUserDetails(data);
            setEditedDetails(data);
          } else {
            console.error("Erro ao obter dados do usuário:", data);
          }
        } catch (error) {
          console.error("Erro ao buscar usuário:", error);
        }
      };

      fetchUserDetails();
      setTimeout(() => setLoading(false), 3000);
    }
  }, [user]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEditedDetails(prevDetails => ({ ...prevDetails, [name]: value }));
  };

 const handleSaveChanges = async () => {
  try {
    const response = await fetch(`https://api.hub4food.colab4food.com/api/users/${user.userId}`, { 
      method: 'PATCH', 
      headers: { 'Content-Type': 'application/json' }, 
      body: JSON.stringify(editedDetails), 
    }); 
     
    const data = await response.json(); 
     
    if (response.ok) { 
      setUserDetails(data); 
      setError(null); 
      showNotification('Dados atualizados com sucesso!', 'success');
    } else { 
      // CAPTURA A MENSAGEM ESPECÍFICA DA API 
      const errorMessage = data.error || data.message || "Erro ao atualizar os dados."; 
      setError(errorMessage); 
       
       
      if (errorMessage.includes('Username já existente')) { 
        showNotification(
          'ATENÇÃO: Este username já está em uso. Por favor, escolha outro username.',
          'error'
        );
      } else {
        showNotification(errorMessage, 'error');
      }
    } 
  } catch (error) { 
    setError("Erro ao conectar com o servidor. Tente novamente."); 
    console.error("Erro ao atualizar usuário:", error); 
    showNotification(
      'Erro ao conectar com o servidor. Tente novamente.',
      'error'
    );
  } 
}; 
 
  return ( 
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}> 
      {/* Navbar */} 
      <BurgerBar /> 
 
      {/* Content */} 
      <Container maxWidth="md" sx={{ flexGrow: 1, p: 4, bgcolor: 'white', borderRadius: 2, boxShadow: 3, textAlign: 'center' }}> 
        <Typography variant="h5" fontWeight="bold" gutterBottom> 
          User Settings 
        </Typography> 
        <Avatar sx={{ width: 90, height: 90, bgcolor: 'primary.main', margin: '0 auto 16px' }} /> 
 
        {loading && <CircularProgress size={24} sx={{ color: 'primary.main' }} />} 
 
        {!loading && userDetails && ( 
          <Box component="form" sx={{ display: 'flex', flexDirection: 'column', gap: 2, maxWidth: 400, margin: '0 auto' }}> 
            <TextField label="Username" name="name" value={editedDetails.name} onChange={handleChange} fullWidth /> 
            <TextField label="Country" name="country" value={editedDetails.country} onChange={handleChange} fullWidth /> 
            <TextField label="Contact" name="contact" value={editedDetails.contact} onChange={handleChange} fullWidth /> 
            <TextField label="Description" name="description" value={editedDetails.description} onChange={handleChange} fullWidth /> 
          </Box> 
        )} 
 
        {error && <Typography variant="body2" color="error">{error}</Typography>} 
 
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}> 
          <Button variant="outlined" color="error" onClick={() => navigate('/ideationPlatform')}>Cancel</Button> 
          <Button variant="contained" color="primary" onClick={handleSaveChanges}>Save Changes</Button> 
        </Box> 
      </Container> 
 
      {/* Footer Moderno */} 
 
           <Box> 
             <Footer> 
      
             </Footer> 
           </Box>

      <Snackbar
        open={notification.open}
        autoHideDuration={4000}
        onClose={handleCloseNotification}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
      >
        <Alert
          onClose={handleCloseNotification}
          severity={notification.severity}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {notification.message}
        </Alert>
      </Snackbar>
    </Box> 
  ); 
}